import script from "./ChangeOrderState.vue?vue&type=script&setup=true&lang=js"
export * from "./ChangeOrderState.vue?vue&type=script&setup=true&lang=js"

import "./ChangeOrderState.vue?vue&type=style&index=0&id=38d6324c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38d6324c"]])

export default __exports__